import { useEnabledFeatures, useIsAuthenticated, useTrackDecisionEvent, useLayers } from '@calendly/feature-check-react'
import { SafeSuspense } from '@calendly/safe-suspense'
import { Loader } from '@calendly/ui/components/loader'
import { lazy } from 'react'

import { useGetUserQuery } from 'common'
import { MFEErrorBoundary } from 'components/mfe_error_boundary'
import { useShareable } from 'features/mfe_shareable'
import { useRightRail } from 'features/right_rail'
import { useCurrentUrlScope } from 'features/scoped_url_state'
import { useTrack } from 'hooks/analytics_events'

export function resolveRemoteCommerceComponent(module) {
  const Component = module.default || module.CreatePackageRail || module
  if (!Component) {
    throw new Error('Invalid component exported from mf_commerce/CreatePackageRail')
  }
  return { default: Component }
}

export function handleRemoteCommerceLoadError(error) {
  console.error('Failed to load Commerce MFE:', error)
  return {
    default: () => null, // TODO: Add fallback component
  }
}

const RemoteCommerceComponent = lazy(() => import('mf_commerce/CreatePackageRail')
  .then(resolveRemoteCommerceComponent)
  .catch(handleRemoteCommerceLoadError)
)

export const RemoteCommercePaneMFE = (props) => {
  const { data: user } = useGetUserQuery()
  const track = useTrack()
  const { close, replace, open } = useRightRail()
  const { paneProps } = useCurrentUrlScope()

  const { open: openShareable } = useShareable()

  const enabledFeatures = useEnabledFeatures()
  const layers = useLayers()
  const isAuthenticated = useIsAuthenticated()
  const trackDecisionEvent = useTrackDecisionEvent()

  return (
    <SafeSuspense fallback={<Loader />}>
      <MFEErrorBoundary>
        <RemoteCommerceComponent
          {...props}
          {...paneProps}
          userUuid={user?.uuid}
          onOpen={open}
          onClose={close}
          onReplace={replace}
          onOpenShareable={openShareable}
          onTrack={track}
          enabledFeatures={enabledFeatures}
          layers={layers}
          isAuthenticated={isAuthenticated}
          trackDecisionEvent={trackDecisionEvent}
        />
      </MFEErrorBoundary>
    </SafeSuspense>
  )
}
